<template>
  <div>
    <a-card title="订购订单">
      <a-row gutter="16" style="margin-bottom:12px">
        <a-col :span="24" style="max-width:220px">
          <a-input v-model="searchForm.search" placeholder="姓名/手机" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="max-width:160px">
          <a-select v-model="searchForm.status" allowClear placeholder="状态" style="width:100%" @change="search">
            <a-select-option value="pending">待处理</a-select-option>
            <a-select-option value="confirmed">已确认</a-select-option>
            <a-select-option value="cancelled">已取消</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" style="width:100px">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>
      </a-row>
      <a-table size="small" rowKey="id" :columns="columns" :dataSource="items" :loading="loading"
        :pagination="pagination" @change="tableChange">
        <div slot="status" slot-scope="v, item">
          <a-tag :color="statusColor(v)">{{ item.status_display || v }}</a-tag>
        </div>
        <div slot="action" slot-scope="v, item">
          <a-button size="small" @click="openDetail(item)">明细</a-button>
          <a-dropdown v-if="item.status === 'pending'">
            <a-button size="small" style="margin-left:8px">状态 <a-icon type="down" /></a-button>
            <a-menu slot="overlay" @click="({ key }) => changeStatus(item, key)">
              <a-menu-item key="confirmed">标记已确认</a-menu-item>
              <a-menu-item key="cancelled">标记已取消</a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-table>
    </a-card>

    <a-modal v-model="detailVisible" title="订单明细" :footer="null" width="720px">
      <div v-if="current.id">
        <p><b>表单：</b>{{ current.form_title }}</p>
        <p><b>客户：</b>{{ current.customer_name }} / {{ current.customer_phone }}</p>
        <p><b>合计：</b>¥{{ current.total_amount }}（{{ current.item_count }} 件）</p>
        <p v-if="current.remark"><b>备注：</b>{{ current.remark }}</p>
        <a-table size="small" rowKey="id" :pagination="false" :dataSource="current.items || []"
          :columns="itemColumns" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { orderFormSubmissionList, orderFormSubmissionUpdate } from '@/api/orderForm'

export default {
  name: 'OrderFormOrders',
  data() {
    return {
      columns: [
        { title: '序号', dataIndex: 'index', customRender: (v, r, i) => i + 1, width: 50 },
        { title: '表单', dataIndex: 'form_title' },
        { title: '姓名', dataIndex: 'customer_name', width: 100 },
        { title: '手机', dataIndex: 'customer_phone', width: 120 },
        { title: '件数', dataIndex: 'item_count', width: 70 },
        { title: '金额', dataIndex: 'total_amount', width: 100 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 90 },
        { title: '提交时间', dataIndex: 'create_time', width: 170 },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 180 },
      ],
      itemColumns: [
        { title: '产品', dataIndex: 'product_name' },
        { title: '规格', dataIndex: 'spec_name', width: 120 },
        { title: '单价', dataIndex: 'price', width: 90 },
        { title: '数量', dataIndex: 'quantity', width: 70 },
        { title: '小计', dataIndex: 'amount', width: 90 },
      ],
      searchForm: { search: '', status: undefined, page: 1, page_size: 16 },
      pagination: { current: 1, total: 0, pageSize: 16 },
      loading: false,
      items: [],
      detailVisible: false,
      current: {},
    }
  },
  methods: {
    statusColor(v) {
      return { pending: 'orange', confirmed: 'green', cancelled: 'red' }[v] || 'default'
    },
    list() {
      this.loading = true
      orderFormSubmissionList(this.searchForm).then((data) => {
        this.items = data.results || []
        this.pagination.total = data.count || 0
      }).finally(() => { this.loading = false })
    },
    search() {
      this.searchForm.page = 1
      this.pagination.current = 1
      this.list()
    },
    tableChange(pagination) {
      this.pagination = pagination
      this.searchForm.page = pagination.current
      this.searchForm.page_size = pagination.pageSize
      this.list()
    },
    openDetail(item) {
      this.current = item
      this.detailVisible = true
    },
    changeStatus(item, status) {
      orderFormSubmissionUpdate({ id: item.id, status }).then(() => {
        this.$message.success('已更新')
        this.list()
      })
    },
  },
  mounted() {
    this.list()
  },
}
</script>
